<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import ModuleTitle from '@/components/layout/ModuleTitle'

  export default {
    name: 'CoachingsModule',
    components: {
      ModuleTitle,
    },
    props: {
      // only get prop options key
      options: {
        type: Object,
        default: _ => {},
      },
    },
    data() {
      return {
        maxRecordsToShow: 10,
      }
    },
    computed: {
      showMore() {
        return this.maxRecordsToShow < this.options.results.length
      },
    },
    methods: {
      viewMore() {
        this.maxRecordsToShow += 10
      },
    },
  }
</script>
